import { Pagination } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

const PaginateReuseAnswers = ({ pages, page, link, id, sid  }) => {
  return (
    pages > 1 && (
      <Pagination className='pagCenterStudent2'>
        {[...Array(pages).keys()].map((x) => (
          <LinkContainer
            key={x + 1}
            to={`/${link}/${x + 1}/${id}/${sid}`}            
          >
            <Pagination.Item active={x + 1 === page}>{x + 1}</Pagination.Item>
          </LinkContainer>
        ))}
      </Pagination>
    )
  );
};

export default PaginateReuseAnswers;
